/**
 * Created by WorkAxis www.workaxis.in
 * Developer: Padma Dev.E
 * Developer Contact: padmadev.e@workaxis.in
 * Admin: shyam@workaxis.in
 * Date: 3/14/2022
 * Time: 2:24 PM
 * Project: w_crm
 */
import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { getCookie } from "../utils/cookies";
import { ACCOUNTS_COOKIE_KEY, ACTIVE_ACCOUNT_COOKIE_KEY } from "../utils/constants";
import { isJwtValid } from "../utils/common";
import { useSelector } from "react-redux";
import { authState } from "../redux/auth/authReducer";
import { ALLOW_PUBLIC_WITH_VALID_LOGIN } from "./Filters";

export default function PublicLayout({ component: Component, ...rest }) {
    let navigate = useNavigate();
    const auth = useSelector(authState);
    const location = useLocation()
    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const state = params.get("state") || "";
        const isAddAccount = params.get("add_account") === "true" || state.includes("add_account=true");
        const hasCode = params.get("code");

        let accessToken = null;
        const activeId = getCookie(ACTIVE_ACCOUNT_COOKIE_KEY);
        if (activeId) {
            try {
                const accounts = JSON.parse(getCookie(ACCOUNTS_COOKIE_KEY) || "[]");
                const acc = accounts.find((acc) => acc.id.toString() === activeId.toString());
                if (acc) accessToken = acc.access;
            } catch (e) { }
        }

        if (accessToken !== null && !isAddAccount && !hasCode) {
            if (isJwtValid(accessToken) && !ALLOW_PUBLIC_WITH_VALID_LOGIN.some(i => location.pathname.match(i))) {
                navigate("/", { replace: true });
            }
        }
    }, [auth, navigate, location.pathname, location.search]);
    return (
        <div className={"public-layout-parent-container"}>
            <div className={"public-layout-parent-holder"}>
                <Component {...rest} />
            </div>
        </div>
    );
}
